function getDateFromString(dateString) {
  let year = dateString.substring(0, 4)
  let month = dateString.substring(4, 6)
  let day = dateString.substring(6, 8)

  return new Date(year, month - 1, day)
}

export default getDateFromString